<template>
  <SelectSubjectFillType
    :statement-type="statementType"
    :role-type="roleType"
    :loading-next="loadingNext"
    :subject-name="SubjectName.DEBTOR"
    @prev="$emit(StepDirection.PREV, $event)"
    @next="$emit(StepDirection.NEXT, $event)"
  />
</template>

<script>
import SelectSubjectFillType from '@/components/services/common/SelectSubjectFillType';
import { SubjectName } from '@/constants';
import { StepDirection } from '@/types/services';

export default {
  name: 'SelectDebtorFillType',
  components: {
    SelectSubjectFillType,
  },
  props: {
    loadingNext: {
      type: Boolean,
      required: true,
    },
    roleType: {
      type: String,
      required: true,
    },
    statementType: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    SubjectName,
    StepDirection,
  }),
};
</script>
